import React, { useEffect, useState } from 'react'
import * as Yup from 'yup';
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './tour.css'
import Footer from '../common/footer/Footer'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, RHFTextField } from '../hook-form';
import Header from '../common/header/Header'
import { Tab, Tabs, Box, Button, Menu, MenuItem, Autocomplete, Typography, TextField, Modal, Stack } from '@mui/material';
import Carousel from 'react-multi-carousel'
import { LoadingButton } from '@mui/lab';
import PropTypes from 'prop-types';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { myProfile, packageBooking, packageGetId } from '../../api/package'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ToastContainer, toast } from 'react-toastify';
import { Padding } from '@mui/icons-material';
import { getImageUrl } from '../../utils/imageUrl';
// -------------------------------------------------


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '25px',
};

const destination = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
    slidesToSlide: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Tour = () => {
  const notify = (message) => toast(message)
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate()
  const token = localStorage.getItem('token')
  const openB = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseB = () => {
    setAnchorEl(null);
  };
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    if (token) {
      setOpen(true)
    } else {
      navigate('/login')
    }

  };
  const handleClose = () => setOpen(false);
  const [value, setValues] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValues(newValue);
  };
  const params = useParams()
  //Profile API

  const [profile, setProfile] = useState('')

  const getProfileData = async () => {
    const resp = await myProfile()
    setProfile(resp.data)
    setValue('name', resp.data.name)
    setValue('email', resp.data.email)
    setValue('mobile', resp.data.mobile)
  }

  useEffect(() => {
    if (token) {
      getProfileData()
    }

  }, [])
  console.log(profile)

  //Tour Data
  const [tourData, setTourData] = useState('')
  const getData = async () => {
    const resp = await packageGetId(params.id)
    setTourData(resp.data)
  }
  useEffect(() => {
    getData()
  }, [])

  const from = localStorage.getItem('from')
  const to = localStorage.getItem('to')

  const theObj = { __html: tourData?.overview };
  const LoginSchema = Yup.object().shape({
    name: Yup.string().required('Name is Required'),
    mobile: Yup.string().matches(/^\d{10}$/, 'must be 10 numbers').required('Mobile is required'),
    email: Yup.string().email().matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      , 'must be valid email').required('Email is required'),
    noOfPersons: Yup.object().shape({

      adult: Yup.number().required('Adult Count is required'),
      child: Yup.number().required('Child Count is required'),
      infant: Yup.number().required('Infant Count is required'),
    }),
    preferredDate: Yup.object().shape({

      from: Yup.number().required('from date is required'),
      to: Yup.number().required('to Count is required'),

    }),
    isVisaRequired: Yup.boolean().required('Visa is required'),
    package: Yup.string().required('Package id is required'),
    specialRequest: Yup.string().required('Special Request id is required')
  });

  const defaultValues = {
    name: profile?.name || '',
    email: profile?.email || '',
    mobile: profile?.mobile || '',
    noOfPersons: {
      adult: 0,
      child: 0,
      infant: 0
    },
    preferredDate: {
      from: dayjs(),
      to: dayjs()
    },
    isVisaRequired: false,
    package: params.id,
    specialRequest: profile?.specialRequest || '',
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    watch,
    setValue,

    handleSubmit,
    formState: { isSubmitting, errors },
  } = methods;

  const values = watch();

  const [adult, setAdult] = useState(0)

  const [child, setChild] = useState(0)

  const [infant, setInfant] = useState(0)


  useEffect(() => {
    if (adult) {
      setValue('noOfPersons.adult', adult)
    } else if (adult === 0) {
      setValue('noOfPersons.adult', 0)
    }
  }, [adult])


  useEffect(() => {
    if (child) {
      setValue('noOfPersons.child', child)
    } else if (child === 0) {
      setValue('noOfPersons.child', 0)
    }
  }, [child])

  useEffect(() => {
    if (infant) {
      setValue('noOfPersons.infant', infant)
    } else if (infant === 0) {
      setValue('noOfPersons.infant', 0)
    }
  }, [infant])
  useEffect(() => {
    if (from) {
      setValue('preferredDate.from', dayjs(from))
    }
  }, [from])

  useEffect(() => {
    if (to) {
      setValue('preferredDate.to', dayjs(to))
    }
  }, [to])


  const onSubmit = async () => {

    if (values.name === '') { notify('Please fill name form carefully') }
    else if (values.email === '') { notify('Please fill email carefully') }
    else if (values.mobile === null) { notify('Please fill mobile carefully') }
    else if (values.mobile?.toString().length !== 10) { notify('Please fill mobile number carefully') }
    else if (values.noOfPersons.adult === 0) { notify('Please fill adult count carefully') }
    else if (values.preferredDate.from === '') { notify('Please fill From Date carefully') }
    else if (values.preferredDate.to === '') {
      notify('Please fill To Date carefully')
    }
    else if (values.isVisaRequired === false && tourData?.packageMode === 'International') {
      notify('Please check your visa required filled carefully')
    }
    else if (values.email.match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    ) {
      if (token) {
        const resp = await packageBooking(values)
        if (resp.code === 201) {

          notify(resp.message)
          handleClose()
          setAdult(0)
          setChild(0)
          setInfant(0)
        }
      } else {
        navigate('/login')
      }
    } else {
      notify('Please fill the email carefully')
    }

  };
  console.log(values)

  return (
    <>
      <Header />
      <section className='py-5'>
        <div className='container'>
          <div className='row p-3'>
            <div className='titleDetail'>
              <h3 className='detailHeading'>{tourData.packageName}</h3>
              <p className="fw-bold mb-0 p-0">
                {tourData?.nightCount} nights - {tourData?.dayCount} Days
              </p>
            </div>
          </div>
          <div>
            <Carousel
              className='tourGallaryImg'
              responsive={destination}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              {tourData?.images?.length > 0 && tourData?.images?.map((items, index) => (
                <Box key={index} className="tourGallery">
                  <img src={getImageUrl(items)} alt='ig' />
                </Box>
              ))}

            </Carousel>
          </div>
          <div className="row g-4 g-xl-5 topCate py-5">
            <div className="col-md-8">
              <Box sx={{ width: '100%' }}>
                {/* <Box sx={{ backgroundColor: '#ddd', borderRadius: '10px', padding: '5px 5px 7px 5px' }}>
                  <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Overview" {...a11yProps(0)} />
                    <Tab label="Itinerary" {...a11yProps(1)} />
                    <Tab label="Inclusions & Exclusion" {...a11yProps(2)} />
                    <Tab label="Tour Policy" {...a11yProps(3)} />
                  </Tabs>
                </Box> */}
                <div className='tourDe'>
                  <h3>Overview</h3>
                  <div dangerouslySetInnerHTML={theObj} />
                </div>
                <div className='tourDe pt-4'>
                  <h3 className='mb-4'>Package Information</h3>
                  <div className='package-info-grid'>
                    <div className='package-info-card'>
                      <div className='package-info-icon location-icon'>
                        <i className="fa-solid fa-location-dot"></i>
                      </div>
                      <div className='package-info-content'>
                        <span className='package-info-label'>Destination</span>
                        <span className='package-info-value'>{tourData?.city}</span>
                      </div>
                    </div>

                    <div className='package-info-card'>
                      <div className='package-info-icon hotel-icon'>
                        <i className="fa-solid fa-hotel"></i>
                      </div>
                      <div className='package-info-content'>
                        <span className='package-info-label'>Accommodation</span>
                        <span className='package-info-value'>{tourData?.hotelType}</span>
                      </div>
                    </div>

                    <div className='package-info-card'>
                      <div className='package-info-icon duration-icon'>
                        <i className="fa-solid fa-calendar-days"></i>
                      </div>
                      <div className='package-info-content'>
                        <span className='package-info-label'>Duration</span>
                        <span className='package-info-value'>{tourData?.dayCount} Days / {tourData?.nightCount} Nights</span>
                      </div>
                    </div>

                    <div className='package-info-card'>
                      <div className='package-info-icon type-icon'>
                        <i className="fa-solid fa-compass"></i>
                      </div>
                      <div className='package-info-content'>
                        <span className='package-info-label'>Package Type</span>
                        <span className='package-info-value'>{tourData?.type}</span>
                      </div>
                    </div>

                    <div className='package-info-card'>
                      <div className='package-info-icon transport-icon'>
                        <i className="fa-solid fa-plane"></i>
                      </div>
                      <div className='package-info-content'>
                        <span className='package-info-label'>Transportation</span>
                        <div className='transport-chips'>
                          {Array.isArray(tourData?.modeOfTransport) ? (
                            tourData.modeOfTransport.map((mode, index) => (
                              <span key={index} className='transport-chip'>
                                {mode}
                              </span>
                            ))
                          ) : (
                            <span className='package-info-value'>{tourData?.modeOfTransport}</span>
                          )}
                        </div>
                      </div>
                    </div>

                    {tourData?.packageMode && (
                      <div className='package-info-card'>
                        <div className='package-info-icon mode-icon'>
                          <i className="fa-solid fa-globe"></i>
                        </div>
                        <div className='package-info-content'>
                          <span className='package-info-label'>Travel Mode</span>
                          <span className='package-info-value'>{tourData?.packageMode}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* <CustomTabPanel value={value} index={0}>
                  <div className='tourDe'>
                    <h3>Overview</h3>
                    <div dangerouslySetInnerHTML={theObj} />
                  </div>
                </CustomTabPanel> */}
                {/* <CustomTabPanel value={value} index={1}>
                  <div className='tourDe'>
                    <h3>Itinerary</h3>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                      >
                        <strong>Day 1 : </strong>Arrival in Kuta | Get ready for an ideal escape on this tropical island
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className="card-header bg-transparent p-0">
                          <span className="text-body dIcon">
                            <svg className="svg-inline--fa fa-circle-check me-2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                              <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                            </svg>
                            Flight details
                          </span>
                          <div className="p-3 bg-light rounded-2 d-sm-flex justify-content-sm-between align-items-center mb-4 mt-2">
                            <h6 className="mb-0">New York - Malaysia</h6>
                            <h6 className="fw-normal mb-0"><span className="text-body">Date:</span> 4 July 2022 </h6>
                          </div>
                        </div>
                        <div className="card-body pb-5">
                          <div className="row g-4">
                            <div className="col-md-3">
                              <img src="../images/download.svg" className="w-80px" alt="" />
                              <h6 className="fw-normal small mb-0">Phillippines Airline</h6>
                            </div>
                            <div className="col-md-3 col-4">
                              <h5>CDG</h5>
                              <h6 className="mb-0">2:50 pm</h6>
                            </div>
                            <div className="col-md-3 col-4 text-center">
                              <h6>5hr 50min</h6>
                              <div className="position-relative my-4">
                                <hr className="bg-primary opacity-5 position-relative" />
                                <div className="icon-md bg-primary text-white rounded-circle position-absolute top-50 start-50 translate-middle">
                                  <svg className="svg-inline--fa fa-plane fa-fw" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plane" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                    <path className="" fill="currentColor" d="M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"></path>
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-3 col-4 text-end">
                              <h5>JFK</h5>
                              <h6 className="mb-0">7:35 pm</h6>
                            </div>
                          </div>
                        </div>
                        <div className="card bg-transparent p-0 border-0">
                          <div className="card-header bg-transparent pb-2 px-0">
                            <span className="text-body dIcon">
                              <svg className="svg-inline--fa fa-circle-check me-2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                              </svg>
                              Transfer from Airport to hotel
                            </span>
                          </div>
                          <div className="card-body p-0 mt-2">
                            <div className="row g-2 g-sm-4 align-items-center">
                              <div className="col-sm-4 col-xl-3">
                                <div className="bg-light rounded-3 px-4 py-5">
                                  <img src="../images/sedan-D95SjZvq.svg" alt="" />
                                </div>
                              </div>
                              <div className="col-sm-8 col-xl-9">
                                <h5 className="card-title mb-1">Private Transfers</h5>
                                <strong>Camry, Accord</strong>
                                <ul className="nav nav-divider mb-2">
                                  <li className="nav-item">SEDAN</li>
                                  <li className="nav-item">AC</li>
                                  <li className="nav-item">4 Seats</li>
                                  <li className="nav-item">2 luggage</li>
                                  <li className="nav-item">First Aid</li>
                                </ul>
                                <a href="#" className="btn btn-sm btn-primary-soft mb-0">Change</a>
                                <a href="#" className="btn btn-sm btn-danger-soft mb-0 ms-1">Remove</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                  <div className='tourDe'>
                    <h3>Inclusions & Exclusions</h3>
                    <h5 className="py-2 mt-2">Inclusion</h5>
                    <ul className="list-group list-group-borderless mb-2">
                      <li className="list-group-item d-flex mb-0">
                        <svg className="svg-inline--fa fa-check text-success me-2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                          <path className="" fill="currentColor" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
                        </svg>
                        <span className="h6 fw-normal">Comfortable stay for 4 nights in your preferred category Hotels</span>
                      </li>
                      <li className="list-group-item d-flex mb-0">
                        <svg className="svg-inline--fa fa-check text-success me-2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                          <path className="" fill="currentColor" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
                        </svg>
                        <span className="h6 fw-normal">Professional English speaking guide to help you explore the cities</span>
                      </li>
                      <li className="list-group-item d-flex mb-0">
                        <svg className="svg-inline--fa fa-check text-success me-2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                          <path className="" fill="currentColor" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
                        </svg>
                        <span className="h6 fw-normal">Breakfast is included as mentioned in Itinerary.</span>
                      </li>
                      <li className="list-group-item d-flex mb-0">
                        <svg className="svg-inline--fa fa-check text-success me-2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                          <path className="" fill="currentColor" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
                        </svg>
                        <span className="h6 fw-normal">Per Peron rate on twin sharing basis</span>
                      </li>
                      <li className="list-group-item d-flex mb-0">
                        <svg className="svg-inline--fa fa-check text-success me-2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                          <path className="" fill="currentColor" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
                        </svg>
                        <span className="h6 fw-normal">Entrance Tickets to Genting Indoor Theme Park</span>
                      </li>
                      <li className="list-group-item d-flex mb-0">
                        <svg className="svg-inline--fa fa-check text-success me-2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                          <path className="" fill="currentColor" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
                        </svg>
                        <span className="h6 fw-normal">All Tours &amp; Transfers on Seat In Coach Basis</span>
                      </li>
                      <li className="list-group-item d-flex mb-0">
                        <svg className="svg-inline--fa fa-check text-success me-2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                          <path className="" fill="currentColor" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
                        </svg>
                        <span className="h6 fw-normal">Visit Bali Safari &amp; Marine Park with Jungle Hopper Pass</span>
                      </li>
                    </ul>
                    <h5 className="py-2 mt-2">Exclusion</h5>
                    <ul className="list-group list-group-borderless mb-2">
                      <li className="list-group-item d-flex mb-0">
                        <svg className="svg-inline--fa fa-xmark text-danger me-2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                          <path className="" fill="currentColor" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
                        </svg>
                        <span className="h6 fw-normal">Lunch and dinner are not included in CP plans</span>
                      </li>
                      <li className="list-group-item d-flex mb-0">
                        <svg className="svg-inline--fa fa-xmark text-danger me-2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                          <path className="" fill="currentColor" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
                        </svg>
                        <span className="h6 fw-normal">Any other services not specifically mentioned in the inclusions</span>
                      </li>
                      <li className="list-group-item d-flex mb-0">
                        <svg className="svg-inline--fa fa-xmark text-danger me-2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                          <path className="" fill="currentColor" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
                        </svg>
                        <span className="h6 fw-normal">Medical and Travel insurance</span>
                      </li>
                      <li className="list-group-item d-flex mb-0">
                        <svg className="svg-inline--fa fa-xmark text-danger me-2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                          <path className="" fill="currentColor" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
                        </svg>
                        <span className="h6 fw-normal">Airfare is not included</span>
                      </li>
                      <li className="list-group-item d-flex mb-0">
                        <svg className="svg-inline--fa fa-xmark text-danger me-2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                          <path className="" fill="currentColor" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
                        </svg>
                        <span className="h6 fw-normal">Early Check-In &amp; Late Check-Out</span>
                      </li>
                      <li className="list-group-item d-flex mb-0">
                        <svg className="svg-inline--fa fa-xmark text-danger me-2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                          <path className="" fill="currentColor" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
                        </svg>
                        <span className="h6 fw-normal">Anything which is not specified in Inclusions</span>
                      </li>
                    </ul>
                  </div>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={3}>
                  <div className='tourDe'>
                    <h3>Tour Policy</h3>
                    <h5 className="py-2 mt-2">Confirmation Policy:</h5>
                    <p>The customer receives a confirmation voucher via email within 24 hours of successful booking.</p>
                    <p>In case the preferred slots are unavailable, an alternate schedule of the customer’s preference will be arranged and a new confirmation voucher will be sent via email. </p>
                    <p>Alternatively, the customer may choose to cancel their booking before confirmation and a full refund will be processed.</p>
                    <h5 className='pt-2'>Cancellation Policy:</h5>
                    <ul className="list-group list-group-borderless">
                      <li className="list-group-item">
                        <span className="h6 fw-normal me-1 mb-0">
                          <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="mb-1">
                            <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"></path>
                          </svg>
                          10 days:
                        </span>
                        <span>100%</span>
                      </li>
                      <li className="list-group-item">
                        <span className="h6 fw-normal me-1 mb-0">
                          <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="mb-1">
                            <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"></path>
                          </svg>
                          10 to 15 days:
                        </span>
                        <span>75% + Non Refundable Component</span>
                      </li>
                      <li className="list-group-item">
                        <span className="h6 fw-normal me-1 mb-0">
                          <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="mb-1">
                            <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"></path>
                          </svg>
                          15 to 30 days:
                        </span>
                        <span>30% + Non Refundable Component</span>
                      </li>
                      <li className="list-group-item">
                        <span className="h6 fw-normal me-1 mb-0">
                          <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="mb-1">
                            <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"></path>
                          </svg>
                          10Hotel / Air:
                        </span>
                        <span>100% in case of non-refundable ticket / Hotel Room</span>
                      </li>
                      <li className="list-group-item">
                        <span className="h6 fw-normal me-1 mb-0">
                          <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="mb-1">
                            <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"></path>
                          </svg>
                          10Cruise / Visa:
                        </span>
                        <span>On Actuals</span>
                      </li>
                    </ul>
                    <p>All Prices are in Indian Rupees and subject to change without prior notice.</p>
                    <p>In the case FIT flight inclusive package, the full amount of the flight will be payable at the time of booking.</p>
                    <h5 className='pt-2'>Refund Policy:</h5>
                    <p>The applicable refund amount will be processed within 10 business days.</p>
                    <p>All applicable refunds will be done in the traveler's Thrillophilia wallet as Thrillcash.</p>
                  </div>
                </CustomTabPanel> */}
              </Box>
            </div>
            <div className="col-md-4">
              <div className="card card-body border bg-transparent prix">
                <div className="hstack gap-2 mb-3">
                  <h3 className="card-title mb-0">₹ {tourData.price}</h3>
                  <span className="fs-5">/Starting</span>
                </div>
                {/* <div className="d-flex justify-content-between mb-4">
                  <ul className="list-inline mb-0 hstack gap-1">
                    <li className="list-inline-item me-1 h6 mb-0">4.5</li>
                    <li className="list-inline-item me-0 small">
                      <i className="fa-solid fa-star"></i>
                    </li>
                    <li className="list-inline-item me-0 small">
                      <i className="fa-solid fa-star"></i>
                    </li>
                    <li className="list-inline-item me-0 small">
                      <i className="fa-solid fa-star"></i>
                    </li>
                    <li className="list-inline-item me-0 small">
                      <i className="fa-solid fa-star"></i>
                    </li>
                    <li className="list-inline-item me-0 small">
                      <i className="fa-solid fa-star"></i>
                    </li>
                  </ul>
                  <a href="#" className="mb-0 m-0 text-reset text-primary-hover">(365 reviews)</a>
                </div> */}
                <div className="d-grid gap-2">
                  {/* <button
                    onClick={async () => {
                      if (token) {
                        const resp = await packageBooking({ package: params?.id, isVisaRequired: true })
                        if (resp.code === 201) {
                          notify(resp.message)
                        }
                      } else {
                        notify('Please login for booking')
                      }
                    }}
                    >Book Now</button> */}
                  <button className="btn btn-primary" onClick={handleOpen}>Book Now</button>
                  <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={style} className='modalBookin'>
                      <Box
                        sx={{
                          position: 'absolute',
                          right: '-15px',
                          top: '-15px',
                          background: '#fff',
                          width: '40px',
                          height: '40px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '50%',
                        }}
                        onClick={handleClose}
                      >
                        <i class="fa-solid fa-xmark"></i>
                      </Box>
                      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>

                        <Stack sx={{ py: 1 }}>
                          <RHFTextField size="small" name="name" label="Name" />
                        </Stack>
                        <Stack sx={{ py: 1 }}>
                          <RHFTextField size="small" type='number' name="mobile" label="Mobile" />
                        </Stack>
                        <Stack sx={{ py: 1 }}>
                          <RHFTextField size="small" name="email" label="Email" />
                        </Stack>
                        <Stack sx={{ py: 1 }}>
                          <Button
                            id="basic-button"
                            aria-controls={openB ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={openB ? 'true' : undefined}
                            onClick={handleClick}
                            className='guestBtn'
                            sx={{
                              border: '1px solid #ddd',
                              justifyContent: 'left',
                            }}
                          >
                            No of Person ({`${values.noOfPersons.adult + values.noOfPersons.child + values.noOfPersons.infant}`})
                          </Button>
                          <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={openB}
                            onClose={handleCloseB}
                            MenuListProps={{
                              'aria-labelledby': 'basic-button',
                            }}
                          >
                            <MenuItem className='muiB'>
                              <ul class="dropdown-menu guest-selector-dropdown show" style={{ position: 'absolute', inset: '0px auto auto 0px', margin: '0px', }} data-popper-placement="bottom-start">
                                <li class="d-flex justify-content-between">
                                  <div>
                                    <h6 class="mb-0">Adult</h6>
                                    <small>Ages 13 or above</small>
                                  </div>
                                  <div class="hstack gap-1 align-items-center">
                                    <button
                                      onClick={() => {
                                        if (adult > 0) {
                                          setAdult(adult - 1)
                                        } else {
                                          setAdult(0)
                                        }



                                      }}
                                      class="btn btn-md btn-link adult-remove p-0 mb-0" type="button">
                                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"></path>
                                      </svg>
                                    </button>
                                    <h6 class="guest-selector-count mb-0 child">{adult}</h6>
                                    <button
                                      onClick={() => {
                                        setAdult(adult + 1)

                                      }}
                                      class="btn btn-md btn-link adult-add p-0 mb-0" type="button">
                                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                      </svg>
                                    </button>
                                  </div>
                                </li>
                                <li class="dropdown-divider"></li>
                                <li class="d-flex justify-content-between">
                                  <div>
                                    <h6 class="mb-0">Child</h6>
                                    <small>2 years to 12 years</small>
                                  </div>
                                  <div class="hstack gap-1 align-items-center">
                                    <button

                                      onClick={() => {
                                        if (child > 0) {
                                          setChild(child - 1)
                                        } else {
                                          setChild(0)
                                        }



                                      }}
                                      class="btn btn-md btn-link adult-remove p-0 mb-0" type="button">
                                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"></path>
                                      </svg>
                                    </button>
                                    <h6 class="guest-selector-count mb-0 child">{child}</h6>
                                    <button

                                      onClick={() => {

                                        setChild(child + 1)




                                      }}
                                      class="btn btn-md btn-link adult-add p-0 mb-0" type="button">
                                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                      </svg>
                                    </button>
                                  </div>
                                </li>
                                <li class="dropdown-divider"></li>
                                <li class="d-flex justify-content-between">
                                  <div>
                                    <h6 class="mb-0">Infant</h6>
                                    <small>0 to 2 Years</small>
                                  </div>
                                  <div class="hstack gap-1 align-items-center">
                                    <button
                                      onClick={() => {
                                        if (infant > 0) {
                                          setInfant(infant - 1)
                                        } else {
                                          setInfant(0)
                                        }



                                      }}
                                      class="btn btn-md btn-link adult-remove p-0 mb-0" type="button">
                                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"></path>
                                      </svg>
                                    </button>
                                    <h6 class="guest-selector-count mb-0 child">{infant}</h6>
                                    <button
                                      onClick={() => {
                                        setInfant(infant + 1)
                                      }}
                                      class="btn btn-md btn-link adult-add p-0 mb-0" type="button">
                                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                      </svg>
                                    </button>
                                  </div>
                                </li>
                              </ul>
                            </MenuItem>
                          </Menu>
                        </Stack>
                        <Stack sx={{ py: 1 }}>
                          <div className='dateCol'>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={['DatePicker']}>
                                <DatePicker
                                  minDate={dayjs()}
                                  slotProps={{ textField: { size: 'small' } }}
                                  label="Start date"
                                  value={values.preferredDate.from}
                                  onChange={(newValue) => {
                                    const date = new Date(newValue['$d']);
                                    setValue('preferredDate.from', date)
                                  }}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                          </div>
                        </Stack>

                        <Stack sx={{ py: 1 }}>
                          <div className='dateCol'>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={['DatePicker']}>
                                <DatePicker
                                  slotProps={{ textField: { size: 'small' } }}
                                  label="End date"
                                  minDate={dayjs(values?.preferredDate?.from)}
                                  value={values.preferredDate.to}
                                  onChange={(newValue) => {
                                    const date = new Date(newValue['$d']);
                                    setValue('preferredDate.to', date)
                                  }}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                          </div>
                        </Stack>

                        <Stack sx={{ py: 1 }} className='txarea'>
                          {/* <RHFTextField size="small" name="" label="Special Request" /> */}
                          <textarea
                            // name="specialRequest" 
                            placeholder='Special Request'
                            rows="3"
                            value={values?.specialRequest}
                            onChange={(e) => { setValue('specialRequest', e.target.value) }}
                          />
                        </Stack>

                        {tourData?.packageMode === 'International' && <Stack sx={{ py: 1 }}>
                          <div className='dateCol chek'>
                            <input type='checkbox' value={values?.isVisaRequired} onChange={(e) => { setValue('isVisaRequired', e.target.checked) }} />
                            <label>Is Visa Required</label>
                          </div>
                        </Stack>}

                        <Stack sx={{ py: 1 }}>
                          <button
                            onClick={onSubmit}
                            fullWidth size="large" type="submit" className='signBtn' >
                            Submit
                          </button>
                        </Stack>
                      </FormProvider>
                    </Box>
                  </Modal>
                  {/* <button

                    className="btn btn-outline-primary mb-0" type="button" data-bs-toggle="modal" data-bs-target="#inquiryForm">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="fa-fw me-1 mb-1">
                      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"></path>
                      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"></path>
                    </svg>
                    Send Inquiry
                  </button> */}
                </div>
              </div>
              <div className="card card-body bg-light p-4 mt-3">
                <h4 className="card-title">Need Help?</h4>
                <ul className="list-group list-group-borderless helpSectio">
                  <li className="pb-2 pt-3">
                    <a href="#!" className="h6 mb-0">
                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="fa-fw text-primary fs-5 me-2">
                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708"></path>
                      </svg>
                      <span className="fw-light me-1">Call us on:</span>+31 123 456 789
                    </a>
                  </li>
                  <li className="py-2">
                    <h6 className="mb-0">
                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="fa-fw text-primary fs-5 me-2">
                        <path d="M8.5 5.5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9z"></path>
                        <path d="M6.5 0a.5.5 0 0 0 0 1H7v1.07a7.001 7.001 0 0 0-3.273 12.474l-.602.602a.5.5 0 0 0 .707.708l.746-.746A6.97 6.97 0 0 0 8 16a6.97 6.97 0 0 0 3.422-.892l.746.746a.5.5 0 0 0 .707-.708l-.601-.602A7.001 7.001 0 0 0 9 2.07V1h.5a.5.5 0 0 0 0-1zm1.038 3.018a6 6 0 0 1 .924 0 6 6 0 1 1-.924 0M0 3.5c0 .753.333 1.429.86 1.887A8.04 8.04 0 0 1 4.387 1.86 2.5 2.5 0 0 0 0 3.5M13.5 1c-.753 0-1.429.333-1.887.86a8.04 8.04 0 0 1 3.527 3.527A2.5 2.5 0 0 0 13.5 1"></path>
                      </svg>
                      <span className="h6 fw-light me-1 mb-0">Timing:</span>10AM to 7PM
                    </h6>
                  </li>
                  {/* <li className="py-2">
                    <a href="#!" className="h6 mb-0">
                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="fa-fw text-primary fs-5 me-2">
                        <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5"></path>
                      </svg>
                      Let Us Call You
                    </a>
                  </li> */}
                  {/* <li className="pt-2 pb-0">
                    <a href="#!" className="h6 mb-0">
                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="fa-fw text-primary fs-5 me-2">
                        <path d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0"></path>
                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"></path>
                      </svg>
                      Book Appointments
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
      <Footer />
    </>
  )
}

export default Tour

const top100Films = [
  { label: 'The Shawshank Redemption', year: 1994 },
  { label: 'The Godfather', year: 1972 },
  { label: 'The Godfather: Part II', year: 1974 },
  { label: 'The Dark Knight', year: 2008 },
  { label: '12 Angry Men', year: 1957 },
  { label: "Schindler's List", year: 1993 },
  { label: 'Pulp Fiction', year: 1994 },
];